import { Comment as CommentType } from '@/types/comment'
import { needReadMore } from '@/utils/format'
import { User, ActionButtons, Comment } from './'

interface Props {
  comment: CommentType
  onActionClick: (type: string, commentId: number) => void
}

export const MemberComment: React.FC<Props> = ({ comment, onActionClick }) => {
  const isReadMore = needReadMore(comment.comment, 2, 130)

  return (
    <div className="p-[30px] mt-3 mb-6 rounded shadow-card">
      <div className="flex">
        <div className="w-full">
          <User comment={comment} />
          <Comment comment={comment} needReadMore={isReadMore} />
          <div>
            <ActionButtons comment={comment} onClick={onActionClick} />
          </div>
        </div>
      </div>
    </div>
  )
}
